import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './LanguageSwitch.css';

const LanguageSwitch = () => {
  const { language, switchLanguage } = useLanguage();

  return (
    <div className="lang-switch">
      <button
        type="button"
        className={`lang-switch-btn ${language === 'en' ? 'lang-switch-btn--active' : ''}`}
        onClick={() => switchLanguage('en')}
        aria-label="English"
      >
        EN
      </button>
      <button
        type="button"
        className={`lang-switch-btn ${language === 'de' ? 'lang-switch-btn--active' : ''}`}
        onClick={() => switchLanguage('de')}
        aria-label="Deutsch"
      >
        DE
      </button>
    </div>
  );
};

export default LanguageSwitch;
